import { ISelectOptions } from "@/utils/models/core";
import { UserActivity } from "@/utils/validators/user-status.validator";

export interface IUpdateStatus {
	setStatusOpen: (x: boolean) => void;
}
export const attendance: ISelectOptions[] = [
	{
		label: "Vacation Leave",
		value: "vacation-leave",
		others: UserActivity.Offline,
	},
	{
		label: "Sick Leave",
		value: "sick-leave",
		others: UserActivity.Offline,
	},
	{
		label: "Carer's Leave",
		value: "carers-leave",
		others: UserActivity.Offline,
	},
];

export const dataStatus: ISelectOptions[] = [
	{
		label: "Unavailable",
		value: "unavailable",
		others: UserActivity.Idle,
	},
	{
		label: "Available",
		value: "clocked-in",
		others: UserActivity.Online,
	},
	{
		label: "On break",
		value: "on-break",
		others: UserActivity.Idle,
	},
];
